export const GET_ALL_BOOKINGS = 'GET_ALL_BOOKINGS'
export const GET_BOOKING_ANALYTICS = 'GET_BOOKING_ANALYTICS'